var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.options.meta[_vm.cellKey])?_c('div',[_c('editor-content',{staticClass:"editor__content",attrs:{"editor":_vm.editor,"onUpdate":"onChange"}})],1):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }